export const DIRECT_CONNECT_PROVIDER_NAME = 'Direct Connect'
